module.exports = "/_next/static/images/game-1-intro-tutorial-underline2-30c53b587cf9e7b52886e4fcea7f3d51.png";